module.exports = __webpack_public_path__ + "img/GenomeBiology-Jingsong-2020.647d7f1e.png";